<template>
  <div id="configuratorDesktop">
    <div id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div class="configuratorDesktop">
      <v-dialog v-model="cartPopup" width="500" >
        <v-card>
          <v-card-title style="background-color: var(--accentColorShaded) !important;" class="headline grey lighten-2">
            <h2 style="color:var(--mainColor);">{{getText.configurator.addedToCart.title1}} {{getText.configurator.addedToCart.title2}}</h2>
          </v-card-title>

          <v-card-text>
            <p style="color: var(--mainColor); text-align: left; padding-top: 10px;">{{getText.configurator.addedToCart.info}}</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="margin-right: 15px;"
              color="var(--mainColor)"
              text
              @click="cartPopup = false"
            >
              {{getText.configurator.addedToCart.close}}
            </v-btn>
            <router-link to="/configuratorDesktop">
              <v-btn
                style="margin-right: 15px;"
                color="var(--mainColor)"
                text
                @click="cartPopup = false"
              >
                {{getText.configurator.addedToCart.furtherProducts}}
              </v-btn>
            </router-link>
            <router-link to="/cartDesktop">
              <v-btn
                color="var(--mainColor)"
                text
                @click="cartPopup = false"
              >
                {{getText.configurator.addedToCart.toCart}}
              </v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="helpPopup" width="500">
        <v-card>
          <v-card-title style="background-color: var(--accentColorShaded) !important;" class="headline grey lighten-2">
            <h2 style="color:var(--mainColor); text-align: left;">{{getHelpText.title1}}{{getHelpText.title2}}</h2>
          </v-card-title>

          <v-card-text>
            <p style="color: var(--mainColor); text-align: left; padding-top: 10px;">{{getHelpText.text}}</p>
            <v-textarea
                style="margin-top: 20px;"
                color="var(--accentColor)"
                outlined
                name="input-7-1"
                :label="getHelpText.message"
                v-model="message"
              ></v-textarea>
              <p style="color: var(--mainColor); text-align: left;">{{getHelpText.contact}}</p>
              <v-textarea
                  height="40"
                  style="margin-top: 20px;"
                  color="var(--accentColor)"
                  outlined
                  name="input-7-1"
                  :label="getHelpText.contactForm"
                  v-model="contact"
                ></v-textarea>

                <v-btn
                  style="margin-right: 15px;"
                  color="var(--mainColor)"
                  text
                  @click="helpPopup = false"
                >
                  {{getHelpText.close}}
                </v-btn>
              <router-link to="/messageSent">
                <v-btn
                  color="var(--mainColor)"
                  text
                  @click="sendMessage()"
                >
                  {{getHelpText.send}}
                </v-btn>
              </router-link>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div style="position: relative; width: 100%; height: 100%;">
        <ConfiguratorBench3d />
        <v-card class="mx-auto cardWrapper" style="position: absolute; bottom: 0; right: 10px;" color="var(--accentColorShaded)" >
          <div class="card">
            <img src="./../../public/icons/plankIndividual.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
            <h3 style="color: var(--mainColor); text-align: left;">{{getText.bulletpoints[2]}}</h3>
          </div>
        </v-card>
        <img v-if="setting !== 'wood'" src="./../../public/icons/3d.svg" style="position: absolute; top: 20px; left: 30px; z-index: 0;" height="60px"/>
        <PriceChip product="bench" :price="getPrice"/>
        <div id="settingsWrapper">
          <div id="settingsAdjustemnt" style="padding: 15px 15px 0 15px !important; position: relative; bottom: 40px;">
            <v-btn style="position: absolute; top: -20px; right: 172px; z-index: 5;" class="mx-2" fab small dark color="var(--accentColor)" @click="viewSettings = !viewSettings" >
            <img v-if="viewSettings" src="./../../public/icons/arrowDown.svg" height="20px"/>
            <img v-if="!viewSettings" src="./../../public/icons/arrowUp.svg" height="20px"/>
            </v-btn>
            <TransitionExpand>
                <Size product="bench" v-if="viewSettings && setting =='dimension'"/>
            </TransitionExpand>
            <TransitionExpand>
              <div v-if="viewSettings && setting =='frame'">
                <FrameButtons product="bench" />
                <Color product="bench" />
              </div>
            </TransitionExpand>
            <TransitionExpand>
              <WoodText product="bench" :mobile="false" v-if="viewSettings && setting =='wood'"/>
            </TransitionExpand>
          </div>
          <v-bottom-navigation mandatory background-color="var(--accentColor)" absolute hide-on-scroll horizontal scroll-target="#hide-on-scroll-example" >
            <v-btn color="white" max-width="40px" text @click="helpPopup = true" style="border-right: solid var(--accentColorShadedTransparent) 1px;">
              <img src="./../../public/icons/help.svg" height="26px"/>
            </v-btn>
            <v-btn color="white" max-width="40px" text @click="set('dimension')" style="border-right: solid var(--accentColorShadedTransparent) 1px;">
              <img src="./../../public/icons/dimensions.svg" height="45px"/>
            </v-btn>
            <v-btn color="white" max-width="40px" text @click="set('frame')" style="border-right: solid var(--accentColorShadedTransparent) 1px;">
              <img src="./../../public/icons/frame.svg" height="45px"/>
            </v-btn>
            <v-btn color="white" max-width="40px" text @click="set('wood')" style="border-right: solid var(--accentColorShadedTransparent) 1px;">
              <img src="./../../public/icons/wood.svg" height="45px"/>
            </v-btn>
            <v-btn color="white" max-width="40px" class="addedToCart" text @click="addToCart()">
              <img src="./../../public/icons/intoCart.svg" height="40px"/>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </div>
    </div>

    <div id="backgroundInformation">
      <div class="centerElementBig" style="margin-top: 25px;">
        <div>

        </div>
        <div>
          <h3>{{getText.infoTeaser}}</h3>
        </div>
        <div>

        </div>
      </div>
      <div id="list">
        <div></div>
        <div>
          <!-- <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/treePlanting.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getText.bulletpoints[0]}}</h3>
            </div>
          </v-card> -->
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/upcycling.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getText.bulletpoints[1]}}</h3>
            </div>
          </v-card>
            <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
              <div class="card">
                <img src="./../../public/icons/plankIndividual.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
                <h3 style="color: var(--mainColor)">{{getText.bulletpoints[2]}}</h3>
              </div>
            </v-card>
        </div>
        <div>
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/discount.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getText.bulletpoints[3]}}</h3>
            </div>
          </v-card>
          <!-- <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/berlin.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getText.bulletpoints[4]}}</h3>
            </div>
          </v-card> -->
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/delivery.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getText.bulletpoints[5]}}</h3>
            </div>
          </v-card>
        </div>
        <div></div>
      </div>
      <div id="pictureView">
        <!-- <div>

        </div>
        <div> -->


        <!-- </div>
        <div>

        </div> -->
      </div>
      <div class="leftRightElement" style="position: relative; margin: 40px 30px;">
        <!-- <div style="position:relative; height: 80vh !important;"> -->
          <!-- <div class="stickyAnimation" style="height: 80vh !important;"> -->
            <!-- <div class="inFromLeft slidePicture"
            style="height: 80vh !important;"
              :class="{ animationSlidein: visibleElement.info }"
              v-observe-visibility="(isVisible) => visibilityChanged(isVisible, 'info')"> -->
              <v-carousel
                progress progress-color="var(--accentColor)" hide-delimiters height="50vw">
                <v-carousel-item
                  v-for="(picture,i) in pictures.mainPictures"
                  :key="i"
                  :src="picture"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                  delimiter-icon="mdi-circle-medium"
                ></v-carousel-item>
              </v-carousel>
            <!-- </div> -->
          <!-- </div> -->
          <div>
            <p style="text-align: left; padding: 0 50px;">
              {{getText.infoGeneralText}}
            </P>
            <p style="text-align: left; padding: 0 50px;">
              <b>{{getText.infoPlanksTitle}}</b><br/>
              {{getText.infoPlanksText}}
            </P>
            <p style="text-align: left; padding: 0 50px;">
              <b>{{getText.infoDeliveryTitle}}</b><br/>
              {{getText.infoDeliveryText}}
            </P>

          </div>
      </div>

      <div id="reviewView">
          <ReviewsTable product="bench" desktop="true"/>
      </div>
      <GetSample desktopConfigurator="true"/>
    </div>
  </div>
</template>

<script>
import ConfiguratorBench3d from '@/components/ConfiguratorBench3d.vue'
// import ConfiguratorBenchWood from '@/components/ConfiguratorBenchWood.vue'
import Size from '@/components/Size.vue'
import Color from '@/components/Color.vue'
import FrameButtons from '@/components/FrameButtons.vue'
import WoodText from '@/components/WoodText.vue'
import ReviewsTable from '@/components/ReviewsTable.vue'
import Navigation from '@/components/Navigation.vue'
import PriceChip from '@/components/PriceChip.vue'
import GetSample from '@/components/GetSample.vue'
import TransitionExpand from '@/components/TransitionExpand.vue'


export default {
  name: 'ConfiguratorDesktop',
  components: {
    ConfiguratorBench3d,
    PriceChip,
    // ConfiguratorBenchWood,
    Size,
    FrameButtons,
    TransitionExpand,
    Color,
    GetSample,
    WoodText,
    ReviewsTable,
    Navigation
  },
  data() {
    return{
      visibleElement: {info:false},
      configuratorComponent: 'size',
      configuratorBack: '',
      configuratorForward: 'weiter: Gestell',
      viewSettings: true,
      setting: "dimension",
      cartPopup: false,
      helpPopup: false,
      message: "",
      contact: "",
      countdown: 30
    }
   },
   mounted (){
    window.scrollTo(0, 0)
     this.countDownTimer()
     // this.$store.dispatch("setBenchPlanks")
     this.$store.dispatch("calculateBenchPrice");
     this.$store.dispatch("setNavbarActive", 1);
   },
   methods: {
     countDownTimer() {
       if(this.countDown > 0) {
           setTimeout(() => {
               this.countDown -= 1
               this.countDownTimer()
           }, 1000)
       } else {
         window.fbq('track', 'CustomizeProduct', {});
       }
     },
     sendMessage(){
       var message = {message: this.message, contact: this.contact, product: "bench"}
       this.helpPopup = false;
       this.$store.dispatch("sendMessage", message);
     },
     set(type){
       this.setting = type
       this.viewSettings = true
     },
     addToCart() {
       this.$store.dispatch("addBenchToCart")
       window.fbq('track', 'AddToCart', {currency: "EUR", value: this.getPrice});
       // this.cartPopup = true
       this.$router.push('/cartDesktop')
     },
     visibilityChanged (isVisible, element) {
       this.visibleElement[element] = isVisible
     },
     configuratorGoBack(){
       if(this.configuratorComponent == 'wood'){
         this.configuratorComponent = 'frame';
         this.configuratorForward = 'weiter: Bohlen';
         this.configuratorBack = 'zurück: Maße';
       } else if (this.configuratorComponent == 'frame') {
         this.configuratorComponent = 'size';
         this.configuratorForward = 'weiter: Gestell';
         this.configuratorBack = '';
       }
     },
     configuratorGoForward(){
       if(this.configuratorComponent == 'size'){
         this.configuratorComponent = 'frame';
         this.configuratorForward = 'weiter: Bohlen';
         this.configuratorBack = 'zurück: Maße';
       } else if (this.configuratorComponent == 'frame') {
         this.configuratorComponent = 'wood';
         this.configuratorForward = '';
         this.configuratorBack = 'zurück: Gestell';
       }
     },
   },
   computed: {
     pictures(){
       return this.$store.getters.getBenchPictureSources
     },
     getHelpText(){
       return this.$store.getters.getText.configurator.questions
     },
     getText(){
       return this.$store.getters.getText.benchConfigurator
     },
     getPrice() {
       return this.$store.getters.getBenchConfig.price;
     },
     topViewWidth(){
       return window.innerWidth - 70
     },
     pictureHeight(){
       var width = window.innerWidth;
       var height = window.innerHeight;

       var smalerDimension = 0;

       if (width > height){
         smalerDimension = height;
       } else {
         smalerDimension = width;
       }

       smalerDimension =- 120
       smalerDimension = smalerDimension + 'px'

       return smalerDimension
     }
   },
}
</script>

<style scoped>
  .inactiveIcon{
    color: var(--mainColor) !important;
  }
  #settingsAdjustemnt {
    box-shadow: inset 0 4px 4px -2px var(--accentColor);
    padding: 5px 10px 0 10px;

    background-color: var(--accentColorShaded);
  }
  #settingsWrapper{
    position: absolute;
    width: 400px;
    max-width: 400px;
    bottom: 0;
    left: 0;
  }
  .cardWrapper{
    margin: 15px 0;
    width: 300px;
    height: 80px;
  }
  .card{
    position: relative;
    display: grid;
    grid-template-columns: 80px 1fr;
    padding: 15px 10px 15px 0;
  }
  #list{
    margin: 30px 0 60px 0;
    text-align: left;
    display: grid;
    position: relative;
    grid-template-columns: 1fr 350px 350px 1fr;
    text-align: left;
    list-style-type: circle;
  }
  #configuratorDesktop {
    position: relative;
    top: var(--desktopNavigationHeight);
    width: 100vw;
  }
  #backgroundInformation {
    position: relative;
    top: calc(var(--desktopNavigationHeight) - 45px);
    width: 100vw;
  }
  ul{
    list-style-type: none;
  }
  #pictureView{
    width: calc(var(--squarePictureMaxDimension) - 120px);
    margin: auto;
  }
  /* #reviewView{
    height: 50vw;
  } */
  #configuratorBottom{
    padding: 0 20px;
    display: grid;
    position: relative;
    grid-template-columns: 70px 1fr 70px;
  }
</style>
